import { GridHit, GridSpec, USB_GRID_V1 } from "./USBAssignedUsersPDFGenerator";
import { NeoStroke } from '../../../neolab-libs/nl-lib3-common/neostroke/NeoStroke';
import { IPageSOBP } from "../../../neolab-libs/nl-lib3-common";
import AssignedStudentsNameProvider from "../AssignedStudentsNameProvider";
import { USBAssignedUsersPDFGenerator } from "./USBAssignedUsersPDFGenerator";
import { IProjectSubmissionStudentNameTransfer } from "../../../repositories/model/transfer/IProjectSubmissionStudentNameTransfer";
import { USBAssignedUserMapping } from "./USBAssignedUserMapping";



export class USBAssignedUserMapper {

    static assignedSOBP: IPageSOBP = {
        section: 3,
        owner: 52,
        book: 1,
        page: 1
    };

    private cachedStudentsName: IProjectSubmissionStudentNameTransfer[] = null;

    // Instance function to generate rubric
    async generatePDF(projectCode: string, projectName: string, curriculumYear: string, spec: GridSpec = USB_GRID_V1) {
        // 1 명단 불러와야 함 by calling getStudentNames function of AssignedStudentsNameProvider object
        const provider = new AssignedStudentsNameProvider();
        const transfers = await provider.getStudentNames(projectCode);

        // 2 call USBAssignedUsersPDFGenerator's function to generate pdf to return it.
        const generator = new USBAssignedUsersPDFGenerator();
        const result = await generator.generatePDF(transfers, spec, USBAssignedUserMapper.assignedSOBP, projectCode, projectName, curriculumYear);
        return result;
    }

    // Instance function to generate rubric
    async hitTest(strokes: NeoStroke[], projectCode: string) {
        // 1 명단 불러와야 함 by calling getStudentNames function of AssignedStudentsNameProvider object
        // 만약 캐쉬가 있다면 캐쉬 쓰자
        // 그 말인즉슨, 이 USBAssignedUserMapper의 생명주기가 짧아야 한다는 의미. 전역으로 쓸 수 없음. 그래야 캐쉬가 날라가지.
        
        let transfers: IProjectSubmissionStudentNameTransfer[] = null;
        if (this.cachedStudentsName) {
            transfers = this.cachedStudentsName;
        } else {
            const provider = new AssignedStudentsNameProvider();
            transfers = await provider.getStudentNames(projectCode);

            // cache transfer
            this.cachedStudentsName = transfers;
        }        

        // 2 find latest strokes
        const maxEndTime = Math.max(...strokes.map(s => s.endTime));
        const latestStrokes = strokes.filter(s => s.endTime === maxEndTime);
        
        if (latestStrokes.length === 0) {
            return null;
        }

        // 3 find the page number of the latest strokes
        const latestPageValue = latestStrokes[0].page-1; // decrement by 1 because the first page starts at index 1
        
        // 4 find the index in the grid
        const mapping = new USBAssignedUserMapping(USB_GRID_V1);
        const hitTestResult = mapping.mapStrokeFirstDotToGrid(latestStrokes[0]);
        
        // 5 
        const numberOfCellsInOnePage = USB_GRID_V1.grid.cols * USB_GRID_V1.grid.rows;        
        const actualIndex = hitTestResult.index + numberOfCellsInOnePage*(latestPageValue);
        
        if (actualIndex >= transfers.length) {
            return null;
        }
        
        const theUserCode = transfers[actualIndex].userCode;
        return theUserCode;
    }
}

